import { render, staticRenderFns } from "./movieGenre.vue?vue&type=template&id=7e95dc16&"
import script from "./movieGenre.vue?vue&type=script&lang=js&"
export * from "./movieGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports